export const CapabilitiesSection: React.FC = () => {
  return (
    <section
      id="capabilities"
      className="capabilities-section section-spacing bg-white"
    >
      <div className="container mx-auto">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-4xl font-bold text-slate-900 mb-6 leading-tight">
            Answers you can trust, because the proof is built in
          </h2>
          <p className="text-lg text-slate-700 leading-relaxed">
            ARK doesn't just respond. It shows the exact drawing detail, spec clause, or RFI response behind every answer, so teams can act quickly with confidence.
          </p>
        </div>

        {/* Evidence panel mockup */}
        <div className="max-w-4xl mx-auto">
          <div className="rounded-2xl border border-slate-200 bg-white shadow-xl overflow-hidden">
            {/* Panel header */}
            <div className="bg-slate-50 border-b border-slate-200 px-6 py-4">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 bg-violet-100 rounded-lg flex items-center justify-center">
                  <svg className="w-5 h-5 text-violet-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <div>
                  <p className="font-semibold text-slate-900">ARK Citation Viewer</p>
                  <p className="text-sm text-slate-600">Evidence-first answers with traceability to source.</p>
                </div>
              </div>
            </div>

            {/* Panel content */}
            <div className="p-6 space-y-4">
              {/* Question */}
              <div className="rounded-lg border border-violet-200 bg-violet-50 p-4">
                <p className="text-sm font-medium text-violet-900">
                  "What fire rating is required for the stairwell doors on floors 3-5?"
                </p>
              </div>

              {/* Answer with citation */}
              <div className="rounded-lg border border-green-200 bg-green-50 p-4">
                <p className="text-sm text-green-900 mb-3">
                  <span className="font-semibold">ARK:</span> Stairwell doors on floors 3-5 require a 90-minute fire rating per Section 08 11 13, paragraph 2.3.2.
                </p>
                <div className="flex items-center gap-2 text-xs text-green-700">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                  </svg>
                  <span>Source: Project Specifications · Door Schedule · Sheet A-401</span>
                </div>
              </div>

              {/* Emphasis quote */}
              <div className="text-center pt-4">
                <p className="text-slate-600 italic">
                  "ARK shows where the answer lives, not just the answer."
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
